module.exports = __webpack_public_path__ + "static/media/burger-logo.b8503d26.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Logo/burger-logo.png
// module id = 43
// module chunks = 0